import RegisterComponent from "../../components/Register";

import { useNavigate } from "react-router-dom";

//const Register = () => {
const Register = props => {
    console.warn('screens/Register(props)', props);

    //const [about, setRegister] = useState(null);
    const navigate = useNavigate()
    // useEffect(() => {
    //   axiosInstance.get('/webcontent?key=about_us').then((res) => {
    //     setRegister(res?.data?.result[0]);
    //   }).catch((err) => {
    //     PopUpAlert("Alert", err?.data?.response?.error ? err?.data?.response?.error : err.message, "error")
    //   })
    // }, []);
    const redirectNft = () => {
        navigate('/search/all')
    }

    return (
        
        <main
            //className = 'item-main edit-profile about'
            //className = 'sensei sensei-light'
            className = 'item-main register'
            >
            <section
                //className={styles.aboutsection}
                //className = 'form property-information'
                className = 'sensei sensei-light'
                //className = 'form'
                style = {{
                    paddingTop: "0px"
                    , paddingBottom: "80px"
                }}
                >
                <div
                    className = { 'max-width' }
                    style = {{ paddingLeft: '0px', paddingRight: '0px' }}
                    >
                    <div
                        //className = 'flex-container'
                        //className = { 'property-information' }
                        //style = {{ textAlign: "left" }}
                        style = {{
                            width: '100%'
                            , maxWidth: "440px"
                            , margin: 'auto'
                        }}
                        >
                        
                        <RegisterComponent
                            keyDownUsername = { props.keyDownUsername }
                            keyDownPassword = { props.keyDownPassword }
                            showCloseButton = { false }
                            showLoginDialog = { props.showLoginDialog }
                            isModal = { false }
                            registerUser = { props.registerUser }
                            registerPasswordRef = { props.registerPasswordRef }
                            registerFormRef = { props.registerFormRef }
                            registerError = { props.registerError }
                            setRegisterError = { props.setRegisterError }
                            />
                        
                    </div>
                </div>
            </section>

        </main>
        
    );
};

export default Register;
